import * as React from 'react';
import { sortBasedOnList } from '../utils';

export interface ITable10ClassProps {
  data: Table10Data;
}

export interface Table10Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

export type Table10Data = { [key: string]: { [key: string]: Table10Row } };


interface ITable10State {
}

const initialState: ITable10State = {
};

const totalRowTitles = [
  "TOTAL AT INTERSECTION",
  "TOTAL NOT AT INTERSECTION",
];

const sortOrder = [
  "Not a Collision Between Two Motor Vehicles",
  "Angle",
  "Front-to-Front",
  "Front-to-Rear",
  "Rear-to-Rear",
  "Rear-to-Side",
  "Sideswipe-Opposite Direction",
  "Sideswipe-Same Direction",
  "Not Stated",
  "Other",
  "Unknown",
  "TOTAL AT INTERSECTION",
  "TOTAL NOT AT INTERSECTION",
]

export default class Table10 extends React.Component<ITable10ClassProps, ITable10State> {
  public constructor(props: any) {
    super(props);
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 21 }} />
              <col style={{ width: 400 }} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2} rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">10</span>
                    <span className="header-text">MULTI-VEHICLE COLLISION TYPE</span>
                  </div>
                </th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2}>PDO **</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.props.data).map((key, index) =>
                sortBasedOnList(this.props.data[key], sortOrder).map((key2, index2) =>
                  <tr
                    key={key2}
                    style={index > 0 && index2 === 0 ? { borderTop: '2px solid black' } : {}}
                    className={totalRowTitles.includes(key2) ? "border-bold bold-text" : null}
                  >
                    {index2 === 0 &&
                      <td rowSpan={Object.keys(this.props.data[key]).length - 1}>
                        <p className="atIntersectionVerticalColumnSmall"
                          style={{ width: '15px' }}
                        >
                          {key}
                        </p>
                      </td>
                    }
                    <td colSpan={totalRowTitles.includes(key2) ? 2 : 1} className="border-right-bold">{key2}</td>
                    <td className="numberTotals">{this.props.data[key][key2].total}</td>
                    <td className="numberTotals">{this.props.data[key][key2].fatal}</td>
                    <td className="numberTotals">{this.props.data[key][key2].injuryA}</td>
                    <td className="numberTotals">{this.props.data[key][key2].injuryB}</td>
                    <td className="numberTotals">{this.props.data[key][key2].injuryC}</td>
                    <td className="numberTotals">{this.props.data[key][key2].pdo}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
